import type { Image, File } from '@sanity/types';

export interface ListingCategory {
  title: string,
  slug: string,
}

export enum LISTING_TYPES {
  ALL = 'listing',
  LATEST = 'latest',
  CATEGORY = 'category',
}

/**
 * [1] Alt text may be defined on the image itself.
 */
export interface ListingPost {
  _id: string,
  _createdAt: string,
  publishedAt: string,
  updatedAt: string,
  language: string,
  title: string,
  pretitle?: string,
  image: Image & { alt?: string } /* [1] */ | null;
  excerpt: string,
  categories: ListingCategory[],
  content: string,
  migrated?: string,
  slug: string,
  file: File,
  url: string
}

export interface ListingParams {
  type?: string,
  locale?: string,
  postsPerPage?: number,
  page?: number,
  createdAt?: string,
  sliceStart?: number,
  sliceEnd?: number,
  taxonomy?: string,
  activeFilter?: Array<string> | undefined | null,
  sanityKey?: string,
}

export interface ListingData {
  totalPosts?: number,
  posts?: ListingPost[] | null,
}

export interface listingFilters {
  slug: string,
  ignoreFilter: string,
}

export const FILTER_ALL = {
  slug: 'all',
};

export const FULL_LISTING_POSTS_NUMBER = 12;
export const SHORT_LISTING_POSTS_NUMBER = 4;
export const MEDIA_ASSETS_POSTS_NUMBER = 9;

export const CAREERS_LIST_LIMIT_PER_PAGE = 8;
